// Force IonPopover remount (Ionic rebinds its trigger by id only on mount) whenever the trigger button is recreated.
export const getExportPopoverKey = (
  hidden: number,
  isCompact: boolean
): string => `${isCompact ? 'compact' : 'normal'}-${hidden}`;
